import { wrapWithDevProxy } from './devProxyFetch';
import type { FetchLike, IntimacyContext } from './types';

/** Cloud BYOK traffic uses our authenticated relay; standalone/dev builds retain their transport. */
export function wrapProviderFetch(fetchImpl: FetchLike, intimacy?: IntimacyContext): FetchLike {
  const configured = (import.meta.env.VITE_PROVIDER_RELAY_URL as string | undefined)?.trim();
  const apiSetting = (import.meta.env.VITE_API_BASE_URL as string | undefined)?.trim().replace(/\/+$/, '');
  const apiBase = apiSetting === undefined || apiSetting === '' ? '/api' : apiSetting;
  const relay = configured === undefined || configured === '' ? (intimacy ? `${apiBase}/v1/providers/relay` : undefined) : configured;
  if ((!import.meta.env.PROD && !intimacy) || !relay) return wrapWithDevProxy(fetchImpl);
  return (input, init) => {
    const target = String(input);
    if (!/^https?:\/\//i.test(target) || new URL(target).origin === location.origin) return fetchImpl(input, init);
    if (init?.body != null && typeof init.body !== 'string') return Promise.reject(new Error('提供商请求格式不受支持'));
    return fetchImpl(relay, {
      method: 'POST', credentials: 'same-origin', signal: init?.signal,
      headers: { 'content-type': 'application/json', accept: init?.headers ? new Headers(init.headers).get('accept') ?? 'application/json' : 'application/json' },
      body: JSON.stringify({ url: target, method: init?.method ?? 'GET', headers: Object.fromEntries(new Headers(init?.headers)), ...(init?.body == null ? {} : { body: init.body }), ...(intimacy ? { intimacy } : {}) }),
    });
  };
}
